import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IContentState, contentTypes } from './types';
import * as contentActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IContentState = {
  userTypes: [],
  userRoles: [],
  circuits: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IContentState, payload: UnsafeReturnType<T>): IContentState;
}

const setUserTypes: IActionHandler<typeof contentActions['setUserTypes']> = (state, { payload }) => ({
  ...state,
  userTypes: payload,
});

const setUserRoles: IActionHandler<typeof contentActions['setUserRoles']> = (state, { payload }) => ({
  ...state,
  userRoles: payload,
});

const setCircuits: IActionHandler<typeof contentActions['setCircuits']> = (state, { payload }) => ({
  ...state,
  circuits: payload,
});
/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [contentTypes.SET_USER_TYPES]: setUserTypes,
  [contentTypes.SET_USER_ROLES]: setUserRoles,
  [contentTypes.SET_CIRCUITS]: setCircuits,
};

const contentReducer = createReducer<IContentState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { contentReducer, contentTypes, contentActions };
